export enum ActionType 
	{
	SetIsLoading = 'SET_IS_LOADING'
}

type SetIsLoadingState = {
	type: ActionType.SetIsLoading;
	isLoading: boolean;
}

export type Actions = SetIsLoadingState;

export const setIsLoading = (isLoading: boolean): SetIsLoadingState => ({
	type: ActionType.SetIsLoading,
	isLoading: isLoading
});
